import { Box, Container } from '@mui/material';

import ErrorBoundary from '@cvt/components/ErrorBoundary';

import { SwipableAssertions as SwipableAssertionsView } from '@modules/Assertions/views/SwipableAssertions';

export const SwipableAssertions = () => {

  return (
    <Box overflow="hidden">
      <Container
        disableGutters
        maxWidth="md"
      >
        <ErrorBoundary>
          <SwipableAssertionsView />
        </ErrorBoundary>
      </Container>
    </Box>
  );
};
